import { MoonLoader } from 'react-spinners'
import './style.scss'
function SpinnerLoader() {
  return (
    <div className="loader">
      {/* <MoonLoader loading={true} speedMultiplier={1} size={50} color="#1561DB" /> */}
      <div className="icon"></div>
    </div>
  )
}

export default SpinnerLoader
